import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import RequireAuth from "./components/RequireAuth";
import { ToastProvider } from "./ui/Toast";
import Admin from "./pages/Admin";
import Ayuda from "./pages/Ayuda";
import Bandeja from "./pages/Bandeja";
import CasoDetalle from "./pages/CasoDetalle";
import Casos from "./pages/Casos";
import Configuracion from "./pages/Configuracion";
import Dashboard from "./pages/Dashboard";
import Estadisticas from "./pages/Estadisticas";
import GuiaDetalle from "./pages/GuiaDetalle";
import Guias from "./pages/Guias";
import Login from "./pages/Login";
import Menciones from "./pages/Menciones";
import ProveedorPendiente from "./pages/ProveedorPendiente";
import Notificaciones from "./pages/Notificaciones";
import Perfil from "./pages/Perfil";
import ResolverTE from "./pages/ResolverTE";
import SalaCierre from "./pages/SalaCierre";
import Shortlinks from "./pages/Shortlinks";
import Ventas from "./pages/Ventas";
import { useAuth } from "./lib/auth";

export default function App() {
  const bootstrap = useAuth((s) => s.bootstrap);
  const loading = useAuth((s) => s.loading);

  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-zinc-500 text-sm">
        Cargando...
      </div>
    );
  }

  return (
    <ToastProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="/estadisticas" element={<Estadisticas />} />
          <Route path="/casos" element={<Casos />} />
          <Route path="/casos/:folio" element={<CasoDetalle />} />
          <Route path="/bandeja" element={<Bandeja />} />
          <Route path="/menciones" element={<Menciones />} />
          <Route path="/proveedor" element={<ProveedorPendiente />} />
          <Route path="/notificaciones" element={<Notificaciones />} />
          <Route path="/perfil" element={<Perfil />} />
          <Route path="/ayuda" element={<Ayuda />} />
          <Route path="/guias" element={<Guias />} />
          <Route path="/guias/:id" element={<GuiaDetalle />} />
          <Route path="/shortlinks" element={<Shortlinks />} />
          <Route path="/ventas" element={<Ventas />} />
          <Route path="/t/:te" element={<ResolverTE />} />
          <Route
            path="/sala-cierre"
            element={
              <RequireAuth dueno>
                <SalaCierre />
              </RequireAuth>
            }
          />
          <Route
            path="/admin"
            element={
              <RequireAuth rol="admin">
                <Admin />
              </RequireAuth>
            }
          />
          <Route
            path="/configuracion"
            element={
              <RequireAuth rol="admin">
                <Configuracion />
              </RequireAuth>
            }
          />
        </Route>
      </Routes>
    </ToastProvider>
  );
}
